<template>
    <dialog ref="dialog" class="dialog" :class="size ? `dialog-${size}` : ''" :aria-labelledby="titleId"
        @close="$emit('close')" @cancel="onCancel" @click="onClick">
        <div class="dialog-inner">
            <div class="dialog-head">
                <h2 :id="titleId">{{ title }}</h2>
                <button v-if="!locked" type="button" class="btn btn-quiet btn-sm btn-icon" aria-label="Schliessen" @click="close">
                    <X />
                </button>
            </div>
            <slot></slot>
        </div>
    </dialog>
</template>

<script>
import { X } from '@lucide/vue';

let dialogCount = 0;

export default {
    name: 'BaseDialog',
    components: { X },
    props: {
        open: Boolean,
        title: String,
        size: String,
        // Unsaved work inside: only the dialog's own buttons may close it
        locked: Boolean,
    },
    emits: ['close'],
    data() {
        return {
            titleId: `dialog-title-${++dialogCount}`,
        }
    },
    mounted() {
        if (this.open) this.$refs.dialog.showModal();
    },
    watch: {
        open: function (open) {
            const dialog = this.$refs.dialog;
            if (open && !dialog.open) dialog.showModal();
            if (!open && dialog.open) dialog.close();
        },
        locked: function (locked) {
            if (locked) document.addEventListener('keydown', this.stopEscape);
            else document.removeEventListener('keydown', this.stopEscape);
        }
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.stopEscape);
    },
    methods: {
        close: function () {
            this.$refs.dialog.close();
        },
        onCancel: function (event) {
            if (this.locked) event.preventDefault();
        },
        // Browsers let a repeated cancel through regardless, so Escape is stopped at the key.
        // On the document, as focus may have left the dialog with the element that held it.
        stopEscape: function (event) {
            if (event.key === 'Escape') event.preventDefault();
        },
        // A click on the backdrop lands on the dialog element itself.
        onClick: function (event) {
            if (event.target === this.$refs.dialog && !this.locked) this.close();
        }
    }
}
</script>
